<avd-styling-card-shell [label]="label" [inverseMode]="inverseMode">
    <div
        token-card-preview
        class="styling_swatch"
        [style.background-color]="
            cssVariableName ? 'var(' + cssVariableName + ')' : 'transparent'
        "
        [class.styling_swatch--inverse]="inverseMode"
    >
        <div class="styling_swatch__content">
            <uilab-mat-form-field
                appearance="outline"
                class="styling_swatch__field--max-width"
            >
                <uilab-mat-label>Example input</uilab-mat-label>
                <input
                    uilabMatInput
                    type="text"
                    value="Container content"
                    aria-label="Example input"
                />
            </uilab-mat-form-field>

            <div class="styling_swatch__actions">
                <button uilabMatButton="text" type="button">Cancel</button>
                <button uilabMatButton="filled" type="button">Next</button>
            </div>
        </div>
    </div>

    <avd-css-variable-snippet
        token-card-snippets
        [snippet]="cssVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
